/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BattleAdminStatsSnapshotDto } from "./BattleAdminStatsSnapshotDto";
export type BattleAdminDetailDto = {
  /**
   * 배틀 ID
   */
  id: string;
  /**
   * 배틀명
   */
  battleName: string;
  /**
   * 대상 퀴즈팩 제목
   */
  quizPackTitle: string | null;
  /**
   * 대상 퀴즈팩 썸네일 (배틀 자체 이미지는 없음)
   */
  quizPackThumbnailUrl: string | null;
  /**
   * 생성자 유저 ID
   */
  creatorUserId: number;
  /**
   * 생성자 닉네임
   */
  creatorNickname: string | null;
  /**
   * 배틀 상태
   */
  status: BattleAdminDetailDto.status;
  /**
   * 참여자 수
   */
  participantCount: number;
  /**
   * 완주자 수
   */
  completerCount: number;
  /**
   * 시작 시각
   */
  startedAt: string;
  /**
   * 마감 시각
   */
  deadline: string;
  /**
   * 생성 시각
   */
  createdAt: string;
  /**
   * 정산된 총 상금 (null = 미정산)
   */
  prizePoolTotal: number | null;
  /**
   * 정산 완료 시각 (null = 미정산)
   */
  settledAt: string | null;
  /**
   * 대상 퀴즈팩 ID
   */
  contentPackId: string;
  /**
   * 대상 퀴즈팩 카테고리명
   */
  quizPackCategoryName: string | null;
  /**
   * 생성자 프로필 이미지
   */
  creatorProfileImageUrl: string | null;
  /**
   * 초대장 힌트 메시지
   */
  hintMessage: string | null;
  /**
   * 수상 인원 (1~3)
   */
  winnerCount: number;
  /**
   * 등수별 상금 비율 (합 100, 예: [50,30,20])
   */
  prizeSplit: Array<number>;
  /**
   * 상금 풀 산정 비율 (기본 0.1)
   */
  baseRewardRate: number;
  /**
   * 공유 횟수
   */
  shareCount: number;
  /**
   * 초대 숏링크 코드
   */
  shortCode: string | null;
  /**
   * 마감 시점 집계 스냅샷 (null = 미정산)
   */
  statsSnapshot: BattleAdminStatsSnapshotDto | null;
};
export namespace BattleAdminDetailDto {
  /**
   * 배틀 상태
   */
  export enum status {
    ACTIVE = "ACTIVE",
    ENDED = "ENDED",
  }
}
